import { selectAdminApiUrl } from 'util/selector/apiSelector';
import { createResourceContentSelector } from 'util/selector/resourceSelector';
import { selectHasMatch } from 'util/selector/routerSelector';

import { AdminRoute } from 'app/route/admin';
import { KioskDistributionModel } from 'api/dto/KioskDistribution.dto';
import { Resource } from 'model/Resource';
import { AdminState } from 'reduxStore/appStore';
import { KioskDistributionState } from 'reduxStore/kioskDistribution/initialState';
import { createSelector } from '@reduxjs/toolkit';

export const selectKioskDistributionDomain = (state: AdminState) =>
  state.kioskDistribution as KioskDistributionState.Domain;

export const selectKioskDistributionResource = createSelector(
  selectKioskDistributionDomain,
  (domain) =>
    (domain && domain.distributionResource) ||
    Resource.createPendingResource<KioskDistributionModel>(),
);

export const selectKioskDistribution = createResourceContentSelector(
  selectKioskDistributionResource,
);

export const selectKioskDistributionId = createSelector(
  selectKioskDistribution,
  (kioskDistribution) => kioskDistribution && kioskDistribution.id,
);

export const selectKioskUniqueCodesUrl = createSelector(
  selectAdminApiUrl,
  selectKioskDistributionId,
  (adminApiUrl, kioskDistributionId) =>
    `${adminApiUrl}/api/v1/distribution/${kioskDistributionId}/access-codes/excel`,
);

export const selectHasMatchRouteKioskDistribution = selectHasMatch(
  AdminRoute.Project.Distribution.KIOSK_PATTERN,
);
